import { getFromRoot } from './helpers/path';

export function getEnvPath(env: 'sandbox' | 'alpha' | 'beta' | 'production'): string {
  return getFromRoot(['', 'env', env].join('.'));
}
